import './App.css';
import LoginPage from "./LoginPage/LoginPage";
import {Navigate, Route, Routes, useParams} from "react-router-dom";
import Navigation from "./Navigation/Navigation.tsx";
import 'bootstrap/dist/css/bootstrap.min.css';
import React, { useEffect } from "react";
import BuildingPage from "./Pages/BuildingDetails/BuildingPage";
import MapOverview from "./MapOverview/MapOverview";
import EkonomiPage from "./Pages/Ekonomi/EkonomiPage";
import ProtectedRoute from "./ProtectedRoute";
import { onAuthStateChanged } from "firebase/auth";
import NotFoundPage from "./Pages/NotFoundPage";
import ForvaltningPage from "./Pages/Förvaltning/ForvaltningPage";
import TimelinePage from "./Pages/Timeline/TimelinePage";
import ProjectsPage from "./Pages/Projects/ProjectsPage";
import AnalysisPage from "./Pages/Analysis/AnalysisPage";
import RoomPage from "./Pages/Room/RoomPage";
import DocumentsPage from "./Pages/Documents/DocumentsPage";
import ComponentPage from "./Pages/ComponentPage/ComponentPage";
import BuildingImagesList from "./Pages/BuildingDetails/BuildingImagesList";
import LevelPage from "./Pages/Level/LevelPage";
import ContactsEditPage from "./Pages/BuildingDetails/ContactsEditPage";
import {HelmetProvider} from "react-helmet-async";
import GenericComponentListPage from "./Pages/BuildingDetails/GenericComponentListPage";
import {BaseType} from "./types/Enums";
import {BuildingProvider} from "./Helpers/BuildingContext";
import {auth} from "./firebase";
import PermitsPage from "./Pages/Permits/PermitsPage";

function App() {

    useEffect(() => {
        document.title = "Molnfastigheter";

        const unsubscribe = onAuthStateChanged(auth, (user) => {
            if (user) {
                //console.log('Signed in');
            } else {
                //console.log('Signed out');
            }
        });

        return () => unsubscribe();

    });

    const RedirectToBuilding = () => {
        const { id } = useParams();
        return <Navigate to={`/building/${id}`} replace />;
    };

    return (
        <HelmetProvider>
            <div className="App">
                <header className="App-header">
                    <BuildingProvider>
                        <Routes>

                            <Route path="/" element={<LoginPage />} />
                            <Route path="/home" element={<LoginPage />} />
                            <Route path="/signIn" element={<LoginPage />} />

                            <Route
                                path="/"
                                element={
                                    <ProtectedRoute>
                                        <Navigation />
                                    </ProtectedRoute>
                                }
                            >
                                <Route index element={<MapOverview />} />
                                <Route path="map" element={<MapOverview />} />
                                <Route path="economy" element={<EkonomiPage />} />
                                <Route path="management" element={<ForvaltningPage />} />
                                <Route path="timeline" element={<TimelinePage />} />
                                <Route path="projects" element={<ProjectsPage />} />
                                <Route path="analysis" element={<AnalysisPage />} />
                                <Route path="building/:id" element={<BuildingPage />} />
                                <Route path="building/:id" element={<BuildingPage />} />
                                <Route path="/building/:id/roof" element={<GenericComponentListPage type={BaseType.Roof}/>} />
                                <Route path="/building/:id/facade" element={<GenericComponentListPage type={BaseType.Facade}/>} />
                                <Route path="/building/:id/foundation" element={<GenericComponentListPage type={BaseType.Foundation}/>} />
                                <Route path="/building/:id/chimney" element={<GenericComponentListPage type={BaseType.Chimney}/>} />
                                <Route path="/building/:id/drainage" element={<GenericComponentListPage type={BaseType.Drainage}/>} />
                                <Route path="/building/:id/blueprints" element={<DocumentsPage />} />
                                <Route path="/building/:id/room/:roomId" element={<RoomPage />} />
                                <Route path="/building/:id/room" element={<RedirectToBuilding />} />
                                <Route path="/building/:id/level/:levelId" element={<LevelPage />} />
                                <Route path="/building/:id/level" element={<RedirectToBuilding />} />
                                <Route path="/building/:buildingKey/component/:itemId" element={<ComponentPage />} />
                                <Route path="/building/:id/allPhotos" element={<BuildingImagesList />} />
                                <Route path="/building/:id/editContacts" element={<ContactsEditPage />} />
                                <Route path="/building/:id/permits" element={<PermitsPage />} />
                                <Route path="*" element={<NotFoundPage />} />

                            </Route>

                        </Routes>
                    </BuildingProvider>
                </header>
            </div>
        </HelmetProvider>
    );
}

export default App;
